import AppContext from "PFApp/app_context";
import { Icon } from "PFComponents/icon";
import Tooltip from "PFComponents/tooltip/tooltip";
import { Typography } from "PFComponents/typography";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

import css from "./filter_label.module.scss";

type FilterLabelProps = {
  title: string;
  name: string;
};

export const FilterLabel = ({ title, name }: FilterLabelProps): JSX.Element => {
  const { t } = useTranslation();
  const {
    store: { customTypes }
  } = useContext(AppContext);

  const isOrderable = customTypes.find((customType) => customType.name === name)?.orderable;

  return (
    <div className={css.root}>
      <Typography variant="bodyRegular" tag="span">
        {title}
      </Typography>
      {isOrderable && (
        <Tooltip
          content={
            <Typography variant="bodyRegular" tag="span">
              {t("filters.hierarchicalFilterMessage")}
            </Typography>
          }
        >
          <div className={css.iconContainer}>
            <Icon name="hierarchical" fill="var(--paletteBlue0)" className={css.icon} />
          </div>
        </Tooltip>
      )}
    </div>
  );
};
